export default __webpack_public_path__ + "static/media/turf-cricket.64940fad.jpg";